/* =========================================================================
   MARKETING Hero — Customer Insight: shared types & category taxonomies.
   Digs Pain / Desire / Objection into the spec's exact sub-categories,
   builds Buying Triggers, Persona, and a Message Map.
   ========================================================================= */

export const PAIN_CATEGORIES: { id: string; label: string }[] = [
  { id: "surface", label: "Surface — ผิวเผิน" },
  { id: "functional", label: "Functional — ใช้งาน" },
  { id: "financial", label: "Financial — การเงิน" },
  { id: "emotional", label: "Emotional — อารมณ์" },
  { id: "social", label: "Social — สังคม" },
  { id: "fear", label: "Fear — ความกลัว" },
  { id: "frustration", label: "Frustration — ความหงุดหงิด" },
  { id: "hidden", label: "Hidden — ซ่อนเร้น" },
];

export const DESIRE_CATEGORIES: { id: string; label: string }[] = [
  { id: "immediate", label: "Immediate — ทันที" },
  { id: "functional", label: "Functional — ใช้งาน" },
  { id: "financial", label: "Financial — การเงิน" },
  { id: "emotional", label: "Emotional — อารมณ์" },
  { id: "status", label: "Status — สถานะ" },
  { id: "lifestyle", label: "Lifestyle — ไลฟ์สไตล์" },
  { id: "transformation", label: "Transformation — เปลี่ยนชีวิต" },
];

export const OBJECTION_CATEGORIES: { id: string; label: string }[] = [
  { id: "price", label: "Price — ราคา" },
  { id: "trust", label: "Trust — ความเชื่อใจ" },
  { id: "time", label: "Time — เวลา" },
  { id: "risk", label: "Risk — ความเสี่ยง" },
  { id: "need", label: "Need — ความจำเป็น" },
  { id: "authority", label: "Authority — อำนาจตัดสินใจ" },
  { id: "past_failure", label: "Past Failure — เคยล้มเหลว" },
  { id: "competitor", label: "Competitor — คู่แข่ง" },
  { id: "decision_delay", label: "Decision Delay — ผัดวันประกันพรุ่ง" },
  { id: "approval", label: "Need Approval — ต้องขออนุมัติ" },
];

export const painLabel = (id: string) => PAIN_CATEGORIES.find((x) => x.id === id)?.label ?? id;
export const desireLabel = (id: string) => DESIRE_CATEGORIES.find((x) => x.id === id)?.label ?? id;
export const objectionLabel = (id: string) => OBJECTION_CATEGORIES.find((x) => x.id === id)?.label ?? id;

export interface InsightInputs {
  product?: string; price?: string; target?: string; customerType?: string;
  ageRange?: string; profession?: string; lifestyle?: string; extra?: string; name?: string;
}

export interface InsightOutput {
  persona: {
    name: string;
    summary: string;
    demographics: string;
    psychographics: string;
    aDayInLife: string;
  };
  pains: { category: string; text: string; intensity: number }[];
  desires: { category: string; text: string }[];
  objections: { category: string; text: string; counter: string; mappedSection: string }[];
  buyingTriggers: string[];
  messageMap: { audienceState: string; coreMessage: string; proof: string }[];
  disclaimer?: string;
}

export const INSIGHT_SCHEMA_HINT = {
  persona: { name: "string", summary: "string", demographics: "string", psychographics: "string", aDayInLife: "string" },
  pains: [{ category: "surface|functional|financial|emotional|social|fear|frustration|hidden", text: "string", intensity: 3 }],
  desires: [{ category: "immediate|functional|financial|emotional|status|lifestyle|transformation", text: "string" }],
  objections: [{ category: "price|trust|time|risk|need|authority|past_failure|competitor|decision_delay|approval", text: "string", counter: "string — วิธีแก้", mappedSection: "string — section/คอนเทนต์ที่ใช้แก้" }],
  buyingTriggers: ["string"],
  messageMap: [{ audienceState: "string — สภาวะผู้อ่าน", coreMessage: "string", proof: "string" }],
};
